import moment from 'moment'
import { THINX_TIME_FORMAT } from 'shared/time-utilites'

const mapVehicle = vehicle => ({
    vehicleId: {
        code: 'vehicleId',
        inactive: false,
        value: vehicle.id,
    },
    color: {
        inactive: false,
        value: vehicle.color,
    },
    make: {
        inactive: false,
        value: vehicle.make,
    },
    model: {
        inactive: false,
        value: vehicle.model,
    },
    plateNumber: {
        inactive: false,
        value: vehicle.tag,
    },
})

export const mapVehicles = vehicles => {
    if (!vehicles) {
        return {}
    }

    return {
        extended: {
            fieldMap: {
                vehicles: {
                    fieldList: vehicles.map(vehicle => ({
                        code: 'vehicle',
                        fieldMap: mapVehicle(vehicle),
                    })),
                },
            },
        },
    }
}

export const formatLocale = locale => locale.replace('-', '_').replace(/_.*$/, match => match.toUpperCase())
export const buildQuery = (valueName, value, fnMap = v => v) =>
    value ? `&${valueName}=${encodeURIComponent(fnMap(value))}` : ''

export const formatDate = startDate =>
    moment(startDate.value)
        .set({ hour: 0 })
        .format(THINX_TIME_FORMAT)
